// import { Component, Input, OnInit, OnDestroy, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
// import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
// import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
// import { Subject } from 'rxjs';
// import { takeUntil, debounceTime, distinctUntilChanged } from 'rxjs/operators';
// import { MatDialog } from '@angular/material/dialog';
// import Swal from 'sweetalert2';

// import { CereriService } from '../../cereri.service';
// import { NotificationService } from '../../../../services/notification.service';
// import { environment } from '../../../../../environments/environment';
// import { helper } from '../../../../../environments/helper';

// import {
//     CerereFunctieAssignment,
//     AssignmentSummary,
//     AssignmentFormData,
//     FunctieData,
//     DirectieData,
//     CompartimentData,
//     UserData,
//     AvailableSelectionsData,
//     AssignmentValidationError,
//     AssignmentStatus,
//     AssignmentStatusTexts,
//     AssignmentStatusClasses,
//     AssignmentDisplayConfig
// } from './cerere-functii-assignment.interface';

// import { ICerere } from '../../cereri.interface';
// import { Generic } from 'src/app/interfaces/generic.interface';

// @Component({
//     selector: 'app-cerere-functii-assignment',
//     templateUrl: './cerere-functii-assignment.component.html',
//     styleUrls: ['./cerere-functii-assignment.component.scss']
// })
// export class CerereFunctiiAssignmentComponent implements OnInit, OnDestroy {
//     private destroy$ = new Subject<void>();

//     @Input() cerere: ICerere | null = null;
//     @Input() directii!: Generic[];
//     @Input() displayConfig: AssignmentDisplayConfig = {
//         showStatus: true,
//         showDraftBadge: true,
//         showUserAvatars: false,
//         compactMode: false,
//         allowEdit: true,
//         allowAssignment: true
//     };
//     @Output() assignmentsUpdated = new EventEmitter<AssignmentSummary>();

//     assignmentForm: FormGroup;
//     assignments: CerereFunctieAssignment[] = [];
//     assignmentSummary: AssignmentSummary | null = null;

//     availableData: AvailableSelectionsData = {
//         functii: [],
//         directii: [],
//         compartimente: [],
//         users: []
//     };

//     // Store compartimente and users per directie/compartiment for better management
//     compartimenteByDirectie: { [directieId: number]: CompartimentData[] } = {};
//     usersByDirectieCompartiment: { [key: string]: UserData[] } = {};

//     // Status constants
//     statusTexts = AssignmentStatusTexts;
//     statusClasses = AssignmentStatusClasses;

//     // Error properties
//     errorTitle: string = environment.config.customNotifications.headers.error;
//     errorIcon: string = environment.config.customNotifications.icons.error;
//     helper = helper;

//     loading = false;
//     saving = false;
//     validationErrors: AssignmentValidationError[] = [];
//     showManagementDialog = false;

//     constructor(
//         private fb: FormBuilder,
//         private cereriService: CereriService,
//         private notificationService: NotificationService,
//         private dialog: MatDialog
//     ) {
//         this.assignmentForm = this.fb.group({
//             assignments: this.fb.array([])
//         });

//         console.log(this.directii);
//     }

//     ngOnInit(): void {
//         if (this.cerere) {
//             this.loadAssignments();
//         }
//     }

//     ngOnDestroy(): void {
//         this.destroy$.next();
//         this.destroy$.complete();
//     }

//     get assignmentsArray(): FormArray {
//         return this.assignmentForm.get('assignments') as FormArray;
//     }

//     /**
//      * Load assignments for the cerere
//      */
//     public refreshAssignments(): void {
//         this.loadAssignments();
//     }

//     /**
//      * Load assignments for the cerere
//      */
//     private loadAssignments(): void {
//         if (!this.cerere) return;

//         this.loading = true;

//         this.cereriService.getCerereAssignments(this.cerere.id_cerere)
//             .pipe(takeUntil(this.destroy$))
//             .subscribe({
//                 next: (response) => {
//                     if (response.success) {
//                         console.log('Cerere assignments response:', response); // Debug log
//                         this.assignments = response.data.assignments || [];
//                         this.assignmentSummary = response.data.summary || null;
//                         console.log('Loaded assignments:', this.assignments); // Debug log
//                         console.log('Assignment summary:', this.assignmentSummary); // Debug log
//                         this.assignmentsUpdated.emit(this.assignmentSummary!);
//                     } else {
//                         console.error('Assignment API returned error:', response);
//                     }
//                 },
//                 error: (error) => {
//                     console.error('Error loading assignments:', error);
//                     this.showErrorMessage('Eroare la încărcarea asignărilor');
//                 },
//                 complete: () => {
//                     this.loading = false;
//                 }
//             });
//     }

//     /**
//      * Initialize assignments from cerere type template
//      */
//     initializeFromTemplate(): void {
//         if (!this.cerere) return;

//         Swal.fire({
//             title: 'Inițializare asignări',
//             text: 'Doriți să inițializați asignările pe baza tipului de cerere?',
//             icon: 'question',
//             showCancelButton: true,
//             confirmButtonText: 'Da, inițializează',
//             cancelButtonText: 'Anulează'
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 this.performInitialization();
//             }
//         });
//     }

//     /**
//      * Clear all assignments for the cerere
//      */
//     clearAllAssignments(): void {
//         if (!this.cerere) return;

//         Swal.fire({
//             title: 'Șterge toate asignările',
//             text: `Sunteți sigur că doriți să ștergeți toate asignările pentru această cerere? Această acțiune nu poate fi anulată.`,
//             icon: 'warning',
//             showCancelButton: true,
//             confirmButtonText: 'Da, șterge toate',
//             cancelButtonText: 'Anulează',
//             confirmButtonColor: '#dc3545'
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 this.performClearAll();
//             }
//         });
//     }

//     private performClearAll(): void {
//         if (!this.cerere) return;

//         this.loading = true;

//         this.cereriService.clearAllCerereAssignments(this.cerere.id_cerere)
//             .pipe(takeUntil(this.destroy$))
//             .subscribe({
//                 next: (response) => {
//                     if (response.success) {
//                         this.showSuccessMessage(response.message || 'Toate asignările au fost șterse cu succes');
//                         this.loadAssignments(); // Reload assignments to update the display
//                     } else {
//                         this.showErrorMessage(response.message || 'Eroare la ștergerea asignărilor');
//                     }
//                 },
//                 error: (error) => {
//                     console.error('Error clearing all assignments:', error);
//                     this.showErrorMessage('Eroare la ștergerea asignărilor');
//                 },
//                 complete: () => {
//                     this.loading = false;
//                 }
//             });
//     }

//     private performInitialization(): void {
//         if (!this.cerere) return;

//         this.loading = true;

//         this.cereriService.initializeCerereAssignments(this.cerere.id_cerere)
//             .pipe(takeUntil(this.destroy$))
//             .subscribe({
//                 next: (response) => {
//                     if (response.success) {
//                         this.showSuccessMessage('Asignările au fost inițializate cu succes');
//                         this.loadAssignments(); // Reload assignments
//                     } else {
//                         this.showErrorMessage(response.message || 'Eroare la inițializarea asignărilor');
//                     }
//                 },
//                 error: (error) => {
//                     console.error('Error initializing assignments:', error);
//                     this.showErrorMessage('Eroare la inițializarea asignărilor');
//                 },
//                 complete: () => {
//                     this.loading = false;
//                 }
//             });
//     }

//     /**
//      * Open assignment management dialog
//      */
//     openManagementDialog(): void {
//         if (!this.cerere) return;

//         // Load available data first
//         Promise.all([
//             this.loadAvailableFunctii(),
//             this.loadAvailableDirectii()
//         ]).then(() => {
//             this.initializeAssignmentForm();
//             this.showManagementDialog = true;
//         }).catch((error) => {
//             console.error('Error loading data for management dialog:', error);
//             this.showErrorMessage('Eroare la încărcarea datelor');
//         });
//     }

//     closeManagementDialog(): void {
//         this.showManagementDialog = false;
//         this.assignmentsArray.clear();
//         this.validationErrors = [];
//     }

//     private async loadAvailableFunctii(): Promise<void> {
//         try {
//             const response = await this.cereriService.getAvailableFunctii().toPromise();
//             if (response?.success) {
//                 this.availableData.functii = response.data;
//             }
//         } catch (error) {
//             console.error('Error loading functii:', error);
//             throw error;
//         }
//     }

//     private async loadAvailableDirectii(): Promise<void> {
//         try {
//             const response = await this.cereriService.getAvailableDirectii().toPromise();
//             if (response?.success) {
//                 this.availableData.directii = response.data;
//             }
//         } catch (error) {
//             console.error('Error loading directii:', error);
//             throw error;
//         }
//     }

//     private initializeAssignmentForm(): void {
//         this.assignmentsArray.clear();

//         if (this.assignments.length > 0) {
//             // Load existing assignments
//             for (const assignment of this.assignments) {
//                 this.addAssignmentFormGroupWithData(assignment);
//             }
//         } else {
//             // Add one empty assignment to start with
//             this.addAssignmentFormGroup();
//         }
//     }

//     private addAssignmentFormGroup(assignment?: CerereFunctieAssignment): void {
//         const assignmentGroup = this.fb.group({
//             id: [assignment?.id || null],
//             functie_id: [assignment?.functie_id || null, Validators.required],
//             directie_id: [assignment?.directie_id || null, Validators.required],
//             compartiment_id: [assignment?.compartiment_id || null],
//             user_id: [assignment?.user_id || null],
//             order_priority: [assignment?.order_priority || this.assignmentsArray.length + 1],
//             assignment_status: [assignment?.assignment_status || 'active']
//         });

//         // Set up cascading selections
//         this.setupCascadingSelections(assignmentGroup, this.assignmentsArray.length);

//         this.assignmentsArray.push(assignmentGroup);
//     }

//     private async addAssignmentFormGroupWithData(assignment: CerereFunctieAssignment): Promise<void> {
//         const assignmentGroup = this.fb.group({
//             id: [assignment.id || null],
//             functie_id: [assignment.functie_id, Validators.required],
//             directie_id: [assignment.directie_id, Validators.required],
//             compartiment_id: [assignment.compartiment_id || null],
//             user_id: [assignment.user_id || null],
//             order_priority: [assignment.order_priority],
//             assignment_status: [assignment.assignment_status]
//         });

//         const currentIndex = this.assignmentsArray.length;

//         // Set up cascading selections
//         this.setupCascadingSelections(assignmentGroup, currentIndex);

//         this.assignmentsArray.push(assignmentGroup);

//         // Load cascading data for existing assignments
//         if (assignment.directie_id) {
//             await this.loadCompartimenteForAssignment(currentIndex, assignment.directie_id);

//             if (assignment.compartiment_id) {
//                 await this.loadUsersForAssignment(currentIndex, assignment.directie_id, assignment.compartiment_id);
//             } else {
//                 await this.loadUsersForAssignment(currentIndex, assignment.directie_id);
//             }
//         }
//     }

//     private setupCascadingSelections(formGroup: FormGroup, index: number): void {
//         // Watch directie changes
//         formGroup.get('directie_id')?.valueChanges
//             .pipe(
//                 takeUntil(this.destroy$),
//                 debounceTime(300),
//                 distinctUntilChanged()
//             )
//             .subscribe((directieId) => {
//                 if (directieId) {
//                     // Clear dependent fields
//                     formGroup.patchValue({
//                         compartiment_id: null,
//                         user_id: null
//                     });

//                     // Load compartimente
//                     this.loadCompartimenteForAssignment(index, directieId);

//                     // Load users for directie only
//                     this.loadUsersForAssignment(index, directieId);
//                 } else {
//                     // Clear all dependent data
//                     this.clearAssignmentSelections(index);
//                 }
//             });

//         // Watch compartiment changes
//         formGroup.get('compartiment_id')?.valueChanges
//             .pipe(
//                 takeUntil(this.destroy$),
//                 debounceTime(300),
//                 distinctUntilChanged()
//             )
//             .subscribe((compartimentId) => {
//                 const directieId = formGroup.get('directie_id')?.value;
//                 if (directieId) {
//                     // Clear user selection
//                     formGroup.patchValue({ user_id: null });

//                     // Load filtered users
//                     this.loadUsersForAssignment(index, directieId, compartimentId);
//                 }
//             });
//     }

//     private async loadCompartimenteForAssignment(assignmentIndex: number, directieId: number): Promise<void> {
//         try {
//             if (!this.compartimenteByDirectie[directieId] && this.cerere?.id_cerere_type) {
//                 const response = await this.cereriService.getCompartimenteByDirectieForCerereType(
//                     this.cerere.id_cerere_type,
//                     directieId
//                 ).toPromise();
//                 if (response?.success) {
//                     this.compartimenteByDirectie[directieId] = response.data;
//                 }
//             }

//             this.availableData.compartimente = this.compartimenteByDirectie[directieId] || [];
//         } catch (error) {
//             console.error('Error loading compartimente:', error);
//         }
//     }

//     private async loadUsersForAssignment(assignmentIndex: number, directieId: number, compartimentId?: number): Promise<void> {
//         try {
//             const cacheKey = `${directieId}_${compartimentId || 'null'}`;

//             if (!this.usersByDirectieCompartiment[cacheKey] && this.cerere?.id_cerere_type) {
//                 const response = await this.cereriService.getAvailableUsersForCerereType(
//                     this.cerere.id_cerere_type,
//                     directieId,
//                     compartimentId
//                 ).toPromise();
//                 if (response?.success) {
//                     // Normalize user data to ensure id_user is available
//                     const normalizedUsers = response.data.map((user: any) => ({
//                         ...user,
//                         id_user: user.id_user || user.id, // Use id_user if available, otherwise use id
//                         id: user.id || user.id_user // Ensure both are available
//                     }));
//                     this.usersByDirectieCompartiment[cacheKey] = normalizedUsers;
//                 }
//             }

//             this.availableData.users = this.usersByDirectieCompartiment[cacheKey] || [];
//         } catch (error) {
//             console.error('Error loading users:', error);
//         }
//     }

//     private clearAssignmentSelections(assignmentIndex: number): void {
//         this.availableData.compartimente = [];
//         this.availableData.users = [];
//     }

//     // Get compartimente for current assignment based on selected directie
//     getCompartimenteForCurrentAssignment(assignmentIndex: number): CompartimentData[] {
//         const assignment = this.assignmentsArray.at(assignmentIndex);
//         const directieId = assignment?.get('directie_id')?.value;
//         return directieId ? this.compartimenteByDirectie[directieId] || [] : [];
//     }

//     // Get users for current assignment based on selected directie/compartiment
//     getUsersForCurrentAssignment(assignmentIndex: number): UserData[] {
//         const assignment = this.assignmentsArray.at(assignmentIndex);
//         const directieId = assignment?.get('directie_id')?.value;
//         const compartimentId = assignment?.get('compartiment_id')?.value;
//         const cacheKey = `${directieId}_${compartimentId || 'null'}`;
//         return directieId ? this.usersByDirectieCompartiment[cacheKey] || [] : [];
//     }

//     // Load data when dropdowns are opened
//     async onCompartimentDropdownOpened(opened: boolean, assignmentIndex: number): Promise<void> {
//         if (opened && this.cerere?.id_cerere_type) {
//             const assignment = this.assignmentsArray.at(assignmentIndex);
//             const directieId = assignment?.get('directie_id')?.value;
//             if (directieId && !this.compartimenteByDirectie[directieId]) {
//                 await this.loadCompartimenteForAssignment(assignmentIndex, directieId);
//             }
//         }
//     }

//     async onUserDropdownOpened(opened: boolean, assignmentIndex: number): Promise<void> {
//         if (opened && this.cerere?.id_cerere_type) {
//             const assignment = this.assignmentsArray.at(assignmentIndex);
//             const directieId = assignment?.get('directie_id')?.value;
//             const compartimentId = assignment?.get('compartiment_id')?.value;
//             if (directieId) {
//                 const cacheKey = `${directieId}_${compartimentId || 'null'}`;
//                 if (!this.usersByDirectieCompartiment[cacheKey]) {
//                     await this.loadUsersForAssignment(assignmentIndex, directieId, compartimentId);
//                 }
//             }
//         }
//     }

//     addNewAssignment(): void {
//         this.addAssignmentFormGroup();
//     }

//     removeAssignment(index: number): void {
//         if (this.assignmentsArray.length > 1) {
//             this.assignmentsArray.removeAt(index);
//             this.reorderAssignments();
//         }
//     }

//     onDrop(event: CdkDragDrop<any>): void {
//         if (event.previousIndex !== event.currentIndex) {
//             const assignmentsArray = this.assignmentsArray;

//             const item = assignmentsArray.at(event.previousIndex);
//             assignmentsArray.removeAt(event.previousIndex);
//             assignmentsArray.insert(event.currentIndex, item);

//             this.reorderAssignments();
//         }
//     }

//     private reorderAssignments(): void {
//         this.assignmentsArray.controls.forEach((control, index) => {
//             control.patchValue({ order_priority: index + 1 });
//         });
//     }

//     async saveAssignments(): Promise<void> {
//         if (!this.validateAssignments()) {
//             return;
//         }

//         if (!this.cerere) return;

//         this.saving = true;

//         try {
//             const assignments = this.assignmentsArray.value.map((assignment: any, index: number) => ({
//                 functie_id: assignment.functie_id,
//                 directie_id: assignment.directie_id,
//                 compartiment_id: assignment.compartiment_id || null,
//                 user_id: assignment.user_id || null,
//                 order_priority: index + 1
//             }));

//             const response = await this.cereriService.updateCerereAssignments(
//                 this.cerere.id_cerere,
//                 { assignments }
//             ).toPromise();

//             if (response?.success) {
//                 this.showSuccessMessage('Asignările au fost salvate cu succes');
//                 this.closeManagementDialog();
//                 this.loadAssignments(); // Reload assignments
//             } else {
//                 this.showErrorMessage('Eroare la salvarea asignărilor');
//             }
//         } catch (error) {
//             console.error('Error saving assignments:', error);
//             this.showErrorMessage('Eroare la salvarea asignărilor');
//         } finally {
//             this.saving = false;
//         }
//     }

//     private validateAssignments(): boolean {
//         this.validationErrors = [];
//         let isValid = true;

//         this.assignmentsArray.controls.forEach((control, index) => {
//             const value = control.value;

//             if (!value.functie_id) {
//                 this.validationErrors.push({
//                     index,
//                     field: 'functie_id',
//                     message: `Asignarea ${index + 1}: Funcția este obligatorie`
//                 });
//                 isValid = false;
//             }

//             if (!value.directie_id) {
//                 this.validationErrors.push({
//                     index,
//                     field: 'directie_id',
//                     message: `Asignarea ${index + 1}: Direcția este obligatorie`
//                 });
//                 isValid = false;
//             }
//         });

//         return isValid;
//     }

//     /**
//      * Assign user to specific function
//      */
//     assignUserToFunction(assignment: CerereFunctieAssignment): void {
//         if (!this.cerere || !assignment.id) return;

//         // Open user selection dialog or directly assign based on UI design
//         this.showUserSelectionDialog(assignment);
//     }

//     private showUserSelectionDialog(assignment: CerereFunctieAssignment): void {
//         // Implementation depends on UI design
//         // This could open a dialog with user selection
//         // For now, we'll show a simple prompt
//         Swal.fire({
//             title: 'Asignare utilizator',
//             text: 'Funcționalitate în dezvoltare',
//             icon: 'info'
//         });
//     }

//     // Display helper methods
//     getStatusDisplayText(status: AssignmentStatus): string {
//         return this.statusTexts[status] || status;
//     }

//     getStatusCssClass(status: AssignmentStatus): string {
//         return this.statusClasses[status] || 'badge-light';
//     }

//     // Notification methods
//     private showSuccessMessage(message: string): void {
//         Swal.fire({
//             title: 'Succes',
//             text: message,
//             icon: 'success',
//             confirmButtonText: this.helper.dialogConfig.buttonLabels.ok,
//         });
//     }

//     private showErrorMessage(message: string): void {
//         this.notificationService.warningSwal(
//             this.errorTitle,
//             message,
//             this.errorIcon
//         );
//     }
// }

import { Component, Input, OnInit, OnDestroy, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Subject, of } from 'rxjs';
import { takeUntil, debounceTime, distinctUntilChanged, switchMap, tap, catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';

import { CereriService } from '../../cereri.service';
import { NotificationService } from '../../../../services/notification.service';
import { environment } from '../../../../../environments/environment';
import { helper } from '../../../../../environments/helper';

import {
    CerereFunctieAssignment,
    AssignmentSummary,
    AssignmentFormData,
    FunctieData,
    DirectieData,
    CompartimentData,
    UserData,
    AvailableSelectionsData,
    AssignmentValidationError,
    AssignmentStatus,
    AssignmentStatusTexts,
    AssignmentStatusClasses,
    AssignmentDisplayConfig
} from './cerere-functii-assignment.interface';

import { ICerere } from '../../cereri.interface';
import { Generic } from 'src/app/interfaces/generic.interface';

@Component({
    selector: 'app-cerere-functii-assignment',
    templateUrl: './cerere-functii-assignment.component.html',
    styleUrls: ['./cerere-functii-assignment.component.scss']
})
export class CerereFunctiiAssignmentComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    @Input() cerere: ICerere | null = null;
    @Input() directii!: Generic[];
    @Input() displayConfig: AssignmentDisplayConfig = {
        showStatus: true,
        showDraftBadge: true,
        showUserAvatars: false,
        compactMode: false,
        allowEdit: true,
        allowAssignment: true
    };
    @Output() assignmentsUpdated = new EventEmitter<AssignmentSummary>();

    assignmentForm: FormGroup;
    assignments: CerereFunctieAssignment[] = [];
    assignmentSummary: AssignmentSummary | null = null;

    availableData: AvailableSelectionsData = {
        functii: [],
        directii: [],
        compartimente: [],
        users: []
    };

    // Store compartimente and users per directie/compartiment for better management
    compartimenteByDirectie: { [directieId: number]: CompartimentData[] } = {};
    usersByDirectieCompartiment: { [key: string]: UserData[] } = {};

    // Typeahead controls for each assignment
    functiiControls: { [index: number]: FormControl } = {};
    directiiControls: { [index: number]: FormControl } = {};
    compartimenteControls: { [index: number]: FormControl } = {};
    usersControls: { [index: number]: FormControl } = {};

    // Filtered data for typeahead
    filteredFunctiiByIndex: { [index: number]: FunctieData[] } = {};
    filteredDirectiiByIndex: { [index: number]: DirectieData[] } = {};
    filteredCompartimenteByIndex: { [index: number]: CompartimentData[] } = {};
    filteredUsersByIndex: { [index: number]: UserData[] } = {};

    // Status constants
    statusTexts = AssignmentStatusTexts;
    statusClasses = AssignmentStatusClasses;

    // Error properties
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    helper = helper;

    loading = false;
    saving = false;
    validationErrors: AssignmentValidationError[] = [];
    showManagementDialog = false;

    constructor(
        private fb: FormBuilder,
        private cereriService: CereriService,
        private notificationService: NotificationService,
        private dialog: MatDialog
    ) {
        this.assignmentForm = this.fb.group({
            assignments: this.fb.array([])
        });

        console.log(this.directii);
    }

    ngOnInit(): void {
        if (this.cerere) {
            this.loadAssignments();
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    get assignmentsArray(): FormArray {
        return this.assignmentForm.get('assignments') as FormArray;
    }

    /**
     * Load assignments for the cerere
     */
    public refreshAssignments(): void {
        this.loadAssignments();
    }

    /**
     * Load assignments for the cerere
     */
    private loadAssignments(): void {
        if (!this.cerere) return;

        this.loading = true;

        this.cereriService.getCerereAssignments(this.cerere.id_cerere)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    if (response.success) {
                        console.log('Cerere assignments response:', response); // Debug log
                        this.assignments = response.data.assignments || [];
                        this.assignmentSummary = response.data.summary || null;
                        console.log('Loaded assignments:', this.assignments); // Debug log
                        console.log('Assignment summary:', this.assignmentSummary); // Debug log
                        this.assignmentsUpdated.emit(this.assignmentSummary!);
                    } else {
                        console.error('Assignment API returned error:', response);
                    }
                },
                error: (error) => {
                    console.error('Error loading assignments:', error);
                    this.showErrorMessage('Eroare la încărcarea asignărilor');
                },
                complete: () => {
                    this.loading = false;
                }
            });
    }

    /**
     * Initialize assignments from cerere type template
     */
    initializeFromTemplate(): void {
        if (!this.cerere) return;

        Swal.fire({
            title: 'Inițializare asignări',
            text: 'Doriți să inițializați asignările pe baza tipului de cerere?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Da, inițializează',
            cancelButtonText: 'Anulează'
        }).then((result) => {
            if (result.isConfirmed) {
                this.performInitialization();
            }
        });
    }

    /**
     * Clear all assignments for the cerere
     */
    clearAllAssignments(): void {
        if (!this.cerere) return;

        Swal.fire({
            title: 'Șterge toate asignările',
            text: `Sunteți sigur că doriți să ștergeți toate asignările pentru această cerere? Această acțiune nu poate fi anulată.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Da, șterge toate',
            cancelButtonText: 'Anulează',
            confirmButtonColor: '#dc3545'
        }).then((result) => {
            if (result.isConfirmed) {
                this.performClearAll();
            }
        });
    }

    private performClearAll(): void {
        if (!this.cerere) return;

        this.loading = true;

        this.cereriService.clearAllCerereAssignments(this.cerere.id_cerere)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    if (response.success) {
                        this.showSuccessMessage(response.message || 'Toate asignările au fost șterse cu succes');
                        this.loadAssignments(); // Reload assignments to update the display
                    } else {
                        this.showErrorMessage(response.message || 'Eroare la ștergerea asignărilor');
                    }
                },
                error: (error) => {
                    console.error('Error clearing all assignments:', error);
                    this.showErrorMessage('Eroare la ștergerea asignărilor');
                },
                complete: () => {
                    this.loading = false;
                }
            });
    }

    private performInitialization(): void {
        if (!this.cerere) return;

        this.loading = true;

        this.cereriService.initializeCerereAssignments(this.cerere.id_cerere)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    if (response.success) {
                        this.showSuccessMessage('Asignările au fost inițializate cu succes');
                        this.loadAssignments(); // Reload assignments
                    } else {
                        this.showErrorMessage(response.message || 'Eroare la inițializarea asignărilor');
                    }
                },
                error: (error) => {
                    console.error('Error initializing assignments:', error);
                    this.showErrorMessage('Eroare la inițializarea asignărilor');
                },
                complete: () => {
                    this.loading = false;
                }
            });
    }

    /**
     * Open assignment management dialog
     */
    openManagementDialog(): void {
        if (!this.cerere) return;

        // Load available data first
        Promise.all([
            this.loadAvailableFunctii(),
            this.loadAvailableDirectii()
        ]).then(() => {
            this.initializeAssignmentForm();
            this.showManagementDialog = true;
        }).catch((error) => {
            console.error('Error loading data for management dialog:', error);
            this.showErrorMessage('Eroare la încărcarea datelor');
        });
    }

    closeManagementDialog(): void {
        this.showManagementDialog = false;
        this.assignmentsArray.clear();
        this.validationErrors = [];
        // Clear typeahead controls
        this.functiiControls = {};
        this.directiiControls = {};
        this.compartimenteControls = {};
        this.usersControls = {};
        this.filteredFunctiiByIndex = {};
        this.filteredDirectiiByIndex = {};
        this.filteredCompartimenteByIndex = {};
        this.filteredUsersByIndex = {};
    }

    private async loadAvailableFunctii(): Promise<void> {
        try {
            const response = await this.cereriService.getAvailableFunctii().toPromise();
            if (response?.success) {
                this.availableData.functii = response.data;
            }
        } catch (error) {
            console.error('Error loading functii:', error);
            throw error;
        }
    }

    private async loadAvailableDirectii(): Promise<void> {
        try {
            const response = await this.cereriService.getAvailableDirectii().toPromise();
            if (response?.success) {
                this.availableData.directii = response.data;
            }
        } catch (error) {
            console.error('Error loading directii:', error);
            throw error;
        }
    }

    private initializeAssignmentForm(): void {
        this.assignmentsArray.clear();

        if (this.assignments.length > 0) {
            // Load existing assignments
            for (const assignment of this.assignments) {
                this.addAssignmentFormGroupWithData(assignment);
            }
        } else {
            // Add one empty assignment to start with
            this.addAssignmentFormGroup();
        }
    }

    private setupTypeaheadControls(index: number): void {
        // Initialize controls for this assignment
        this.functiiControls[index] = new FormControl();
        this.directiiControls[index] = new FormControl();
        this.compartimenteControls[index] = new FormControl();
        this.usersControls[index] = new FormControl();

        // Initialize filtered arrays
        this.filteredFunctiiByIndex[index] = [...this.availableData.functii];
        this.filteredDirectiiByIndex[index] = [...this.availableData.directii];
        this.filteredCompartimenteByIndex[index] = [];
        this.filteredUsersByIndex[index] = [];

        // Setup typeahead for Functii
        this.functiiControls[index].valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (!inputValue || inputValue.length < 1) {
                    this.filteredFunctiiByIndex[index] = [...this.availableData.functii];
                    return of(this.availableData.functii);
                }
                return this.filterFunctii(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredFunctiiByIndex[index] = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        // Setup typeahead for Directii
        this.directiiControls[index].valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (!inputValue || inputValue.length < 1) {
                    this.filteredDirectiiByIndex[index] = [...this.availableData.directii];
                    return of(this.availableData.directii);
                }
                return this.filterDirectii(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectiiByIndex[index] = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        // Setup typeahead for Compartimente
        this.compartimenteControls[index].valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (!inputValue || inputValue.length < 1) {
                    this.filteredCompartimenteByIndex[index] = this.getCompartimenteForCurrentAssignment(index);
                    return of(this.getCompartimenteForCurrentAssignment(index));
                }
                return this.filterCompartimente(inputValue, index);
            }),
            tap((data: any[]) => {
                this.filteredCompartimenteByIndex[index] = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        // Setup typeahead for Users
        this.usersControls[index].valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (!inputValue || inputValue.length < 1) {
                    this.filteredUsersByIndex[index] = this.getUsersForCurrentAssignment(index);
                    return of(this.getUsersForCurrentAssignment(index));
                }
                return this.filterUsers(inputValue, index);
            }),
            tap((data: any[]) => {
                this.filteredUsersByIndex[index] = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    // Typeahead filter methods
    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    filterFunctii(searchTerm: string) {
        const normalizedSearchTerm = this.normalizeString(searchTerm);
        const filtered = this.availableData.functii.filter(functie =>
            this.normalizeString(functie.name).includes(normalizedSearchTerm)
        );
        return of(filtered);
    }

    filterDirectii(searchTerm: string) {
        const normalizedSearchTerm = this.normalizeString(searchTerm);
        const filtered = this.availableData.directii.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );
        return of(filtered);
    }

    filterCompartimente(searchTerm: string, assignmentIndex: number) {
        const normalizedSearchTerm = this.normalizeString(searchTerm);
        const availableCompartimente = this.getCompartimenteForCurrentAssignment(assignmentIndex);
        const filtered = availableCompartimente.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );
        return of(filtered);
    }

    filterUsers(searchTerm: string, assignmentIndex: number) {
        const normalizedSearchTerm = this.normalizeString(searchTerm);
        const availableUsers = this.getUsersForCurrentAssignment(assignmentIndex);
        const filtered = availableUsers.filter(user =>
            this.normalizeString(user.name || user.full_name || '').includes(normalizedSearchTerm)
        );
        return of(filtered);
    }

    // Typeahead close handlers
    onFunctieSelectClosed(assignmentIndex: number) {
        const selectedValue = this.functiiControls[assignmentIndex].value;
        if (selectedValue) {
            const assignment = this.assignmentsArray.at(assignmentIndex);
            const isSelectedInFilteredList = this.filteredFunctiiByIndex[assignmentIndex].some(functie =>
                functie.id === assignment?.get('functie_id')?.value
            );

            if (!isSelectedInFilteredList) {
                this.functiiControls[assignmentIndex].setValue(null);
                this.filteredFunctiiByIndex[assignmentIndex] = [...this.availableData.functii];
            }
        }
    }

    onDirectieSelectClosed(assignmentIndex: number) {
        const selectedValue = this.directiiControls[assignmentIndex].value;
        if (selectedValue) {
            const assignment = this.assignmentsArray.at(assignmentIndex);
            const isSelectedInFilteredList = this.filteredDirectiiByIndex[assignmentIndex].some(directie =>
                directie.id_directie === assignment?.get('directie_id')?.value
            );

            if (!isSelectedInFilteredList) {
                this.directiiControls[assignmentIndex].setValue(null);
                this.filteredDirectiiByIndex[assignmentIndex] = [...this.availableData.directii];
            }
        }
    }

    onCompartimentSelectClosed(assignmentIndex: number) {
        const selectedValue = this.compartimenteControls[assignmentIndex].value;
        if (selectedValue) {
            const assignment = this.assignmentsArray.at(assignmentIndex);
            const isSelectedInFilteredList = this.filteredCompartimenteByIndex[assignmentIndex].some(compartiment =>
                compartiment.id_compartiment === assignment?.get('compartiment_id')?.value
            );

            if (!isSelectedInFilteredList) {
                this.compartimenteControls[assignmentIndex].setValue(null);
                this.filteredCompartimenteByIndex[assignmentIndex] = this.getCompartimenteForCurrentAssignment(assignmentIndex);
            }
        }
    }

    onUserSelectClosed(assignmentIndex: number) {
        const selectedValue = this.usersControls[assignmentIndex].value;
        if (selectedValue) {
            const assignment = this.assignmentsArray.at(assignmentIndex);
            const isSelectedInFilteredList = this.filteredUsersByIndex[assignmentIndex].some(user =>
                user.id_user === assignment?.get('user_id')?.value
            );

            if (!isSelectedInFilteredList) {
                this.usersControls[assignmentIndex].setValue(null);
                this.filteredUsersByIndex[assignmentIndex] = this.getUsersForCurrentAssignment(assignmentIndex);
            }
        }
    }

    private addAssignmentFormGroup(assignment?: CerereFunctieAssignment): void {
        const assignmentGroup = this.fb.group({
            id: [assignment?.id || null],
            functie_id: [assignment?.functie_id || null, Validators.required],
            directie_id: [assignment?.directie_id || null, Validators.required],
            compartiment_id: [assignment?.compartiment_id || -1],
            user_id: [assignment?.user_id || -1],
            order_priority: [assignment?.order_priority || this.assignmentsArray.length + 1],
            assignment_status: [assignment?.assignment_status || 'active']
        });

        const currentIndex = this.assignmentsArray.length;

        // Set up typeahead controls
        this.setupTypeaheadControls(currentIndex);

        // Set up cascading selections
        this.setupCascadingSelections(assignmentGroup, currentIndex);

        this.assignmentsArray.push(assignmentGroup);
    }

    private async addAssignmentFormGroupWithData(assignment: CerereFunctieAssignment): Promise<void> {
        const assignmentGroup = this.fb.group({
            id: [assignment.id || null],
            functie_id: [assignment.functie_id, Validators.required],
            directie_id: [assignment.directie_id, Validators.required],
            compartiment_id: [assignment.compartiment_id || -1],
            user_id: [assignment.user_id || -1],
            order_priority: [assignment.order_priority],
            assignment_status: [assignment.assignment_status]
        });

        const currentIndex = this.assignmentsArray.length;

        // Set up typeahead controls
        this.setupTypeaheadControls(currentIndex);

        // Set up cascading selections
        this.setupCascadingSelections(assignmentGroup, currentIndex);

        this.assignmentsArray.push(assignmentGroup);

        // Load cascading data for existing assignments
        if (assignment.directie_id) {
            await this.loadCompartimenteForAssignment(currentIndex, assignment.directie_id);

            if (assignment.compartiment_id) {
                await this.loadUsersForAssignment(currentIndex, assignment.directie_id, assignment.compartiment_id);
            } else {
                await this.loadUsersForAssignment(currentIndex, assignment.directie_id);
            }
        }
    }

    private setupCascadingSelections(formGroup: FormGroup, index: number): void {
        // Watch directie changes
        formGroup.get('directie_id')?.valueChanges
            .pipe(
                takeUntil(this.destroy$),
                debounceTime(300),
                distinctUntilChanged()
            )
            .subscribe((directieId) => {
                if (directieId) {
                    // Clear dependent fields
                    formGroup.patchValue({
                        compartiment_id: -1,
                        user_id: -1
                    });

                    // Load compartimente
                    this.loadCompartimenteForAssignment(index, directieId);

                    // Load users for directie only
                    this.loadUsersForAssignment(index, directieId);
                } else {
                    // Clear all dependent data
                    this.clearAssignmentSelections(index);
                }
            });

        // Watch compartiment changes
        formGroup.get('compartiment_id')?.valueChanges
            .pipe(
                takeUntil(this.destroy$),
                debounceTime(300),
                distinctUntilChanged()
            )
            .subscribe((compartimentId) => {
                const directieId = formGroup.get('directie_id')?.value;
                if (directieId) {
                    // Clear user selection
                    formGroup.patchValue({ user_id: -1 });

                    // Load filtered users
                    const actualCompartimentId = compartimentId === -1 ? undefined : compartimentId;
                    this.loadUsersForAssignment(index, directieId, actualCompartimentId);
                }
            });
    }

    private async loadCompartimenteForAssignment(assignmentIndex: number, directieId: number): Promise<void> {
        try {
            if (!this.compartimenteByDirectie[directieId] && this.cerere?.id_cerere_type) {
                const response = await this.cereriService.getCompartimenteByDirectieForCerereType(
                    this.cerere.id_cerere_type,
                    directieId
                ).toPromise();
                if (response?.success) {
                    this.compartimenteByDirectie[directieId] = response.data;
                }
            }

            // Update filtered compartimente for this assignment
            this.filteredCompartimenteByIndex[assignmentIndex] = this.compartimenteByDirectie[directieId] || [];
        } catch (error) {
            console.error('Error loading compartimente:', error);
        }
    }

    private async loadUsersForAssignment(assignmentIndex: number, directieId: number, compartimentId?: number): Promise<void> {
        try {
            const actualCompartimentId = compartimentId === -1 ? undefined : compartimentId;
            const cacheKey = `${directieId}_${actualCompartimentId || 'null'}`;

            if (!this.usersByDirectieCompartiment[cacheKey] && this.cerere?.id_cerere_type) {
                const response = await this.cereriService.getAvailableUsersForCerereType(
                    this.cerere.id_cerere_type,
                    directieId,
                    actualCompartimentId
                ).toPromise();
                if (response?.success) {
                    // Normalize user data to ensure id_user is available
                    const normalizedUsers = response.data.map((user: any) => ({
                        ...user,
                        id_user: user.id_user || user.id, // Use id_user if available, otherwise use id
                        id: user.id || user.id_user // Ensure both are available
                    }));
                    this.usersByDirectieCompartiment[cacheKey] = normalizedUsers;
                }
            }

            // Update filtered users for this assignment
            this.filteredUsersByIndex[assignmentIndex] = this.usersByDirectieCompartiment[cacheKey] || [];
        } catch (error) {
            console.error('Error loading users:', error);
        }
    }

    private clearAssignmentSelections(assignmentIndex: number): void {
        // Clear filtered data for this assignment
        this.filteredCompartimenteByIndex[assignmentIndex] = [];
        this.filteredUsersByIndex[assignmentIndex] = [];
    }

    // Get compartimente for current assignment based on selected directie
    getCompartimenteForCurrentAssignment(assignmentIndex: number): CompartimentData[] {
        const assignment = this.assignmentsArray.at(assignmentIndex);
        const directieId = assignment?.get('directie_id')?.value;
        return directieId ? this.compartimenteByDirectie[directieId] || [] : [];
    }

    // Get users for current assignment based on selected directie/compartiment
    getUsersForCurrentAssignment(assignmentIndex: number): UserData[] {
        const assignment = this.assignmentsArray.at(assignmentIndex);
        const directieId = assignment?.get('directie_id')?.value;
        const compartimentId = assignment?.get('compartiment_id')?.value;
        const actualCompartimentId = compartimentId === -1 ? undefined : compartimentId;
        const cacheKey = `${directieId}_${actualCompartimentId || 'null'}`;
        return directieId ? this.usersByDirectieCompartiment[cacheKey] || [] : [];
    }

    // Load data when dropdowns are opened
    async onCompartimentDropdownOpened(opened: boolean, assignmentIndex: number): Promise<void> {
        if (opened && this.cerere?.id_cerere_type) {
            const assignment = this.assignmentsArray.at(assignmentIndex);
            const directieId = assignment?.get('directie_id')?.value;
            if (directieId && !this.compartimenteByDirectie[directieId]) {
                await this.loadCompartimenteForAssignment(assignmentIndex, directieId);
            }
        }
    }

    async onUserDropdownOpened(opened: boolean, assignmentIndex: number): Promise<void> {
        if (opened && this.cerere?.id_cerere_type) {
            const assignment = this.assignmentsArray.at(assignmentIndex);
            const directieId = assignment?.get('directie_id')?.value;
            const compartimentId = assignment?.get('compartiment_id')?.value;
            if (directieId) {
                const actualCompartimentId = compartimentId === -1 ? undefined : compartimentId;
                const cacheKey = `${directieId}_${actualCompartimentId || 'null'}`;
                if (!this.usersByDirectieCompartiment[cacheKey]) {
                    await this.loadUsersForAssignment(assignmentIndex, directieId, actualCompartimentId);
                }
            }
        }
    }

    addNewAssignment(): void {
        this.addAssignmentFormGroup();
    }

    removeAssignment(index: number): void {
        if (this.assignmentsArray.length > 1) {
            // Clean up typeahead controls
            delete this.functiiControls[index];
            delete this.directiiControls[index];
            delete this.compartimenteControls[index];
            delete this.usersControls[index];

            delete this.filteredFunctiiByIndex[index];
            delete this.filteredDirectiiByIndex[index];
            delete this.filteredCompartimenteByIndex[index];
            delete this.filteredUsersByIndex[index];

            this.assignmentsArray.removeAt(index);
            this.reorderAssignments();

            // Reindex the remaining controls
            this.reindexTypeaheadControls(index);
        }
    }

    private reindexTypeaheadControls(removedIndex: number): void {
        // Shift all controls down by one index for items after the removed index
        const maxIndex = Math.max(...Object.keys(this.functiiControls).map(k => parseInt(k)));

        for (let i = removedIndex; i < maxIndex; i++) {
            const nextIndex = i + 1;
            if (this.functiiControls[nextIndex]) {
                this.functiiControls[i] = this.functiiControls[nextIndex];
                this.directiiControls[i] = this.directiiControls[nextIndex];
                this.compartimenteControls[i] = this.compartimenteControls[nextIndex];
                this.usersControls[i] = this.usersControls[nextIndex];

                this.filteredFunctiiByIndex[i] = this.filteredFunctiiByIndex[nextIndex];
                this.filteredDirectiiByIndex[i] = this.filteredDirectiiByIndex[nextIndex];
                this.filteredCompartimenteByIndex[i] = this.filteredCompartimenteByIndex[nextIndex];
                this.filteredUsersByIndex[i] = this.filteredUsersByIndex[nextIndex];

                delete this.functiiControls[nextIndex];
                delete this.directiiControls[nextIndex];
                delete this.compartimenteControls[nextIndex];
                delete this.usersControls[nextIndex];

                delete this.filteredFunctiiByIndex[nextIndex];
                delete this.filteredDirectiiByIndex[nextIndex];
                delete this.filteredCompartimenteByIndex[nextIndex];
                delete this.filteredUsersByIndex[nextIndex];
            }
        }
    }

    onDrop(event: CdkDragDrop<any>): void {
        if (event.previousIndex !== event.currentIndex) {
            const assignmentsArray = this.assignmentsArray;

            const item = assignmentsArray.at(event.previousIndex);
            assignmentsArray.removeAt(event.previousIndex);
            assignmentsArray.insert(event.currentIndex, item);

            // Also move the typeahead controls
            this.moveTypeaheadControls(event.previousIndex, event.currentIndex);

            this.reorderAssignments();
        }
    }

    private moveTypeaheadControls(fromIndex: number, toIndex: number): void {
        // Store the controls and filtered data
        const functieControl = this.functiiControls[fromIndex];
        const directieControl = this.directiiControls[fromIndex];
        const compartimentControl = this.compartimenteControls[fromIndex];
        const userControl = this.usersControls[fromIndex];

        const filteredFunctii = this.filteredFunctiiByIndex[fromIndex];
        const filteredDirectii = this.filteredDirectiiByIndex[fromIndex];
        const filteredCompartimente = this.filteredCompartimenteByIndex[fromIndex];
        const filteredUsers = this.filteredUsersByIndex[fromIndex];

        // Create a temporary mapping for the move
        const tempControls: any = {};
        const tempFiltered: any = {};

        // Collect all existing controls
        Object.keys(this.functiiControls).forEach(key => {
            const index = parseInt(key);
            tempControls[index] = {
                functie: this.functiiControls[index],
                directie: this.directiiControls[index],
                compartiment: this.compartimenteControls[index],
                user: this.usersControls[index]
            };
            tempFiltered[index] = {
                functii: this.filteredFunctiiByIndex[index],
                directii: this.filteredDirectiiByIndex[index],
                compartimente: this.filteredCompartimenteByIndex[index],
                users: this.filteredUsersByIndex[index]
            };
        });

        // Clear all controls
        this.functiiControls = {};
        this.directiiControls = {};
        this.compartimenteControls = {};
        this.usersControls = {};
        this.filteredFunctiiByIndex = {};
        this.filteredDirectiiByIndex = {};
        this.filteredCompartimenteByIndex = {};
        this.filteredUsersByIndex = {};

        // Rebuild controls with new indices
        const indices = Object.keys(tempControls).map(k => parseInt(k)).sort((a, b) => a - b);

        indices.forEach((oldIndex, arrayIndex) => {
            let newIndex = arrayIndex;

            // Adjust for the move
            if (oldIndex === fromIndex) {
                newIndex = toIndex;
            } else if (fromIndex < toIndex && oldIndex > fromIndex && oldIndex <= toIndex) {
                newIndex = arrayIndex - 1;
            } else if (fromIndex > toIndex && oldIndex >= toIndex && oldIndex < fromIndex) {
                newIndex = arrayIndex + 1;
            }

            this.functiiControls[newIndex] = tempControls[oldIndex].functie;
            this.directiiControls[newIndex] = tempControls[oldIndex].directie;
            this.compartimenteControls[newIndex] = tempControls[oldIndex].compartiment;
            this.usersControls[newIndex] = tempControls[oldIndex].user;

            this.filteredFunctiiByIndex[newIndex] = tempFiltered[oldIndex].functii;
            this.filteredDirectiiByIndex[newIndex] = tempFiltered[oldIndex].directii;
            this.filteredCompartimenteByIndex[newIndex] = tempFiltered[oldIndex].compartimente;
            this.filteredUsersByIndex[newIndex] = tempFiltered[oldIndex].users;
        });
    }

    private reorderAssignments(): void {
        this.assignmentsArray.controls.forEach((control, index) => {
            control.patchValue({ order_priority: index + 1 });
        });
    }

    async saveAssignments(): Promise<void> {
        if (!this.validateAssignments()) {
            return;
        }

        if (!this.cerere) return;

        this.saving = true;

        try {
            const assignments = this.assignmentsArray.value.map((assignment: any, index: number) => ({
                functie_id: assignment.functie_id,
                directie_id: assignment.directie_id,
                compartiment_id: assignment.compartiment_id === -1 ? null : assignment.compartiment_id,
                user_id: assignment.user_id === -1 ? null : assignment.user_id,
                order_priority: index + 1
            }));

            const response = await this.cereriService.updateCerereAssignments(
                this.cerere.id_cerere,
                { assignments }
            ).toPromise();

            if (response?.success) {
                this.showSuccessMessage('Asignările au fost salvate cu succes');
                this.closeManagementDialog();
                this.loadAssignments(); // Reload assignments
            } else {
                this.showErrorMessage('Eroare la salvarea asignărilor');
            }
        } catch (error) {
            console.error('Error saving assignments:', error);
            this.showErrorMessage('Eroare la salvarea asignărilor');
        } finally {
            this.saving = false;
        }
    }

    private validateAssignments(): boolean {
        this.validationErrors = [];
        let isValid = true;

        this.assignmentsArray.controls.forEach((control, index) => {
            const value = control.value;

            if (!value.functie_id) {
                this.validationErrors.push({
                    index,
                    field: 'functie_id',
                    message: `Asignarea ${index + 1}: Funcția este obligatorie`
                });
                isValid = false;
            }

            if (!value.directie_id) {
                this.validationErrors.push({
                    index,
                    field: 'directie_id',
                    message: `Asignarea ${index + 1}: Direcția este obligatorie`
                });
                isValid = false;
            }
        });

        return isValid;
    }

    /**
     * Assign user to specific function
     */
    assignUserToFunction(assignment: CerereFunctieAssignment): void {
        if (!this.cerere || !assignment.id) return;

        // Open user selection dialog or directly assign based on UI design
        this.showUserSelectionDialog(assignment);
    }

    private showUserSelectionDialog(assignment: CerereFunctieAssignment): void {
        // Implementation depends on UI design
        // This could open a dialog with user selection
        // For now, we'll show a simple prompt
        Swal.fire({
            title: 'Asignare utilizator',
            text: 'Funcționalitate în dezvoltare',
            icon: 'info'
        });
    }

    // Display helper methods
    getStatusDisplayText(status: AssignmentStatus): string {
        return this.statusTexts[status] || status;
    }

    getStatusCssClass(status: AssignmentStatus): string {
        return this.statusClasses[status] || 'badge-light';
    }

    // Notification methods
    private showSuccessMessage(message: string): void {
        Swal.fire({
            title: 'Succes',
            text: message,
            icon: 'success',
            confirmButtonText: this.helper.dialogConfig.buttonLabels.ok,
        });
    }

    private showErrorMessage(message: string): void {
        this.notificationService.warningSwal(
            this.errorTitle,
            message,
            this.errorIcon
        );
    }
}